// this file is auto generated by ng g @mooxy/schematics:data-access if you want to edit actions the
// recommended way is using the following command:
// ng g @mooxy/schematics:effect
import {Injectable} from '@angular/core';
import * as ContractPartnersActions from './contractPartners.actions';
import {map} from "rxjs/operators";
import {ContractPartnersPartialState} from './contractPartners.reducer';
import {Actions, createEffect} from '@ngrx/effects';
import {ContractPartnersConnectors} from './contractPartners.connectors';
import {DataPersistence, withCorrelationIdOf} from "@kion/ngrx-helper";
import {ContractPartner} from "@kion/data-models";

@Injectable()
export class ContractPartnersEffects {
  loadAll$ = createEffect(() =>
    this.dataPersistence.fetch(
      ContractPartnersActions.loadAll,
      {
        run: (
          action: ReturnType<typeof ContractPartnersActions.loadAll>
        ) => {
          return this.connectors.getAll().pipe(
            map(
              (contractPartners: ContractPartner[]) => withCorrelationIdOf(
                action,
                ContractPartnersActions.loadAllSuccess({contractPartners})
              )
            )
          );
        },
        onError: (
          action: ReturnType<typeof ContractPartnersActions.loadAll>,
          error
        ) => {
          console.error('Error', error);
          return withCorrelationIdOf(
            action,
            ContractPartnersActions.loadAllError({error: error})
          );
        }
      }
    )
  )
  setContractPartner$ = createEffect(() =>
    this.dataPersistence.fetch(
      ContractPartnersActions.setContractPartner,
      {
        run: (
          action: ReturnType<typeof ContractPartnersActions.setContractPartner>
        ) => {
          return this.connectors.setContractPartner(action.networkPartnerId, action.cartId).pipe(
            map(
              () => withCorrelationIdOf(
                action,
                ContractPartnersActions.setContractPartnerSuccess()
              )
            )
          );
        },
        onError: (
          action: ReturnType<typeof ContractPartnersActions.setContractPartner>,
          error
        ) => {
          console.error('Error', error);
          return withCorrelationIdOf(
            action,
            ContractPartnersActions.setContractPartnerError({error: error})
          );
        }
      }
    )
  )

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<ContractPartnersPartialState>,
    private connectors: ContractPartnersConnectors
  ) {
  }

}

